export const calculateTimeTaken = (startTime, timeRemaining) => {
    return startTime - timeRemaining;
};
